import { email } from "react-admin";

const BranchValidation = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }

  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }

  if (!values.address) {
    // You can return translation keys
    errors.address = "Address is required";
  }

  if (!values.phone) {
    errors.phone = "Phone number is required";
  }

  if (values.phone) {
    if (String(values.phone).length !== 17) {
      errors.phone = "Wrong phone format";
    }
  }

  if (!values.email) {
    // You can return translation keys
    errors.email = "Email is required";
  } else {
    const validateEmail = email();
    if (validateEmail(values.email)) {
      errors.email = "Wrong email format";
    }
  }
  return errors;
};

export default BranchValidation;
